export default __webpack_public_path__ + "static/media/pt_ear.d19163e2.svg";